import { render } from "./ListCustomer.vue?vue&type=template&id=e0c6b430&scoped=true"
import script from "./ListCustomer.vue?vue&type=script&lang=js"
export * from "./ListCustomer.vue?vue&type=script&lang=js"

import "./ListCustomer.vue?vue&type=style&index=0&id=e0c6b430&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c6b430"]])

export default __exports__